import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { UserAPIService } from 'src/app/extensions/services/api/user-api.service';
import { USER_RIGHT_WRITE } from 'src/app/extensions/constants/commonConstants';
import { ROUTES } from 'src/app/core/constants/routes-constants';

@Injectable()
export class RequestRightsGuard {
  constructor(
    private _router: Router,
    private _userAPIService: UserAPIService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._userAPIService.getUserRights().pipe(
      map(result => {
        const userRights = result.rights.map(x => x.code);

        const requestWizardRights = [
          'RW_RequestAssetDrivingAbroadList',
          'RW_RequestAssetDamageDelegacyList',
          'RW_RequestAssetOtherList',
          'RW_RequestAssetVignetteList',
        ];
        const contractModificationRights = [
          'RW_RequestContractReimbursementList',
          'RW_RequestContractInstallmentDeferralList',
          'RW_RequestContractOtherList',
        ];
        const clientDataRights = [
          'RW_RequestClientDataAddressList',
          'RW_RequestClientDataContactInformationList',
          'RW_RequestClientDataBeneficialOwnerList',
          'RW_RequestClientDataAssociateList',
          'RW_RequestClientDataCompanyInformationList',
          'RW_RequestClientDataLegalRepresentativeList',
          'RW_RequestClientDataPersonalInformationList',
          'RW_RequestClientDataOtherList',
        ];

        const fullRoutePath =
          '/' +
          route.pathFromRoot
            .reduce<string[]>((acc, snap) => {
              return acc.concat(snap.url.map(segment => segment.path));
            }, [])
            .filter(Boolean)
            .join('/');

        let rightsList: string[] = [];

        if (fullRoutePath.startsWith('/requests/new')) {
          rightsList = requestWizardRights;
        } else if (fullRoutePath.startsWith('/requests/contract-modifications/new')) {
          rightsList = contractModificationRights;
        } else if (fullRoutePath.startsWith('/requests/client-data/new')) {
          rightsList = clientDataRights;
        }

        if (userRights.some(userRight => rightsList.includes(userRight))) {
          return true;
        }

        this._router.navigateByUrl(ROUTES.UNAUTHORIZED_ROUTE_URL);
        return false;
      })
    );
  }
}
